import type React from "react";
import styles from "./index.module.scss";

interface ProgressBarProps {
  progress: number; // 0-100
  className?: string | undefined;
  showPercentage?: boolean | undefined;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  className,
  showPercentage = false,
}) => {
  const clampedProgress = Math.max(10, Math.min(100, progress));

  return (
    <div className={styles["progressContainer"]}>
      {showPercentage && (
        <div className={styles["progressHeader"]}>
          <span className={styles["progressLabel"]}>進行状況</span>
          <span className={styles["progressPercentage"]}>{clampedProgress}%</span>
        </div>
      )}
      <div className={`${styles["progressBar"]} ${className || ""}`}>
        <div className={styles["progressFill"]} style={{ width: `${clampedProgress}%` }} />
      </div>
    </div>
  );
};

export default ProgressBar;
